import {
	SET_QUOTATION,
	RESET_QUOTATION,
} from './action-types';

export function setQuotationAction(quotation) {
	return {
		type: SET_QUOTATION,
		quotation,
	};
}

export function resetQuotationAction() {
	return {
		type: RESET_QUOTATION,
	};
}

